/**
 * Loeb CSS-tokeni arvutatud väärtuse, et diagrammid (Leaflet, canvas jm, mis ei
 * mõista `var()`-viiteid) saaksid sama värvi mis CSS — ka tumedas teemas.
 * SVG-atribuudid (stroke/fill) võtavad `var(--x)` otse; readToken on vaja
 * ainult seal, kus väärtus läheb CSS-ist välja.
 */
export const readToken = (name: string): string => {
    if (typeof document === 'undefined' || typeof getComputedStyle !== 'function') return ''
    return getComputedStyle(document.documentElement).getPropertyValue(name).trim()
}

/** Diagrammide kategooriavärvid järjekorras --chart-1 … --chart-6. */
export const chartPalette = (): string[] => [1, 2, 3, 4, 5, 6].map((i) => readToken(`--chart-${i}`))
